import { render } from "./ExamReportTab.vue?vue&type=template&id=c05b6546&scoped=true"
import script from "./ExamReportTab.vue?vue&type=script&lang=js"
export * from "./ExamReportTab.vue?vue&type=script&lang=js"

import "./ExamReportTab.vue?vue&type=style&index=0&id=c05b6546&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c05b6546"]])

export default __exports__